import request from "utils/request";
import requestJWT from "utils/requestJWT";

const getAllApi = async () => {
    return await request.get(`/news-category/`);
};

const getAllByAdminApi = async (page) => {
    return await requestJWT.get(`/news-category/get-all-by-admin?page=${page}&item=5`);
};

const createApi = async (data) => {
    return await requestJWT.post(`/news-category/create`, data);
};

const updateApi = async (id, data) => {
    return await requestJWT.put(`/news-category/${id}/update`, data);
};

const deleteApi = async (id) => {
    return await requestJWT.delete(`/news-category/${id}/remove`);
};

export {
    getAllByAdminApi,
    createApi,
    updateApi,
    deleteApi,
    getAllApi
};
